export default {"src":"/_next/static/media/gimp.d563c9d7.svg","height":256,"width":296,"blurWidth":0,"blurHeight":0};